var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g, _g2, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixel9Pro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 892,
    viewBox: "0 0 423 892",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418.608 242.444V242.444C419.929 242.444 421 243.515 421 244.836V307.041C421 308.362 419.929 309.433 418.608 309.433V309.433V242.444Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M418.608 354.89V354.89C419.929 354.89 421 355.961 421 357.282V476.906C421 478.227 419.929 479.298 418.608 479.298V479.298V354.89Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.7612,
    y: 2,
    width: 275.085,
    height: 8.37366,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7612,
    y: 883.626,
    width: 275.085,
    height: 8.37366,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 820.226,
    width: 746.452,
    height: 8.37219,
    transform: "rotate(-90 0 820.226)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 418.608,
    y: 73.7742,
    width: 746.452,
    height: 8.37219,
    transform: "rotate(90 418.608 73.7742)",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7614 883.626C37.0827 883.626 8.37216 854.911 8.37216 820.226H0C0 859.535 32.4589 892 71.7614 892V883.626Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0654 871.279C39.168 885.451 55.2792 890.804 71.7616 890.804V886.019C51.4513 886.019 35.2227 876.578 26.2415 870.029C23.0133 867.675 22.2472 868.447 25.0654 871.279Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.729 863.163C5.63048 849.335 1.19629 832.988 1.19629 820.226L6.61098 820.226C6.61098 838.832 13.7042 853.436 19.1076 861.998C21.2887 865.455 20.42 866.239 17.729 863.163Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.847 883.626C381.525 883.626 410.236 854.911 410.236 820.226H418.608C418.608 859.535 386.149 892 346.847 892V883.626Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M393.543 871.279C379.44 885.451 363.329 890.804 346.846 890.804V886.019C367.157 886.019 383.385 876.578 392.366 870.029C395.595 867.675 396.361 868.447 393.543 871.279Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400.879 863.163C412.977 849.335 417.412 832.988 417.412 820.226L411.997 820.226C411.997 838.832 404.904 853.436 399.5 861.998C397.319 865.455 398.188 866.239 400.879 863.163Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7614 10.3737C37.0827 10.3737 8.37216 39.0894 8.37216 73.7742H0C0 34.4647 32.4589 2 71.7614 2V10.3737Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0654 22.721C39.168 8.54894 55.2792 3.19629 71.7616 3.19629V7.98124C51.4513 7.98124 35.2227 17.4217 26.2415 23.9708C23.0133 26.3248 22.2472 25.5531 25.0654 22.721Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.729 30.8371C5.63048 44.6653 1.19629 61.0118 1.19629 73.7742L6.61098 73.7742C6.61098 55.1676 13.7042 40.5639 19.1076 32.0015C21.2887 28.5452 20.42 27.7613 17.729 30.8371Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.847 10.3737C381.525 10.3737 410.236 39.0894 410.236 73.7742H418.608C418.608 34.4647 386.149 2 346.847 2V10.3737Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M393.543 22.721C379.44 8.54894 363.329 3.19629 346.846 3.19629V7.98124C367.157 7.98124 383.385 17.4217 392.366 23.9708C395.595 26.3248 396.361 25.5531 393.543 22.721Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M400.879 30.8371C412.977 44.6653 417.412 61.0118 417.412 73.7742L411.997 73.7742C411.997 55.1676 404.904 40.5639 399.5 32.0015C397.319 28.5452 398.188 27.7613 400.879 30.8371Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 139.567,
    width: 8.37216,
    height: 9.56989,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8.37216,
    height: 9.56995,
    transform: "matrix(1 0 0 -1 0 802.282)",
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 410.236,
    y: 139.567,
    width: 8.37216,
    height: 9.56989,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 8.37216,
    height: 9.56995,
    transform: "matrix(1 0 0 -1 410.236 802.282)",
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204.52,
    y: 10.3737,
    width: 8.37366,
    height: 9.56818,
    transform: "rotate(-90 204.52 10.3737)",
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.37366,
    height: 9.56818,
    transform: "matrix(-4.37035e-08 1 1 4.37192e-08 254.155 883.626)",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_109_477)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.304,
    cy: 51.0457,
    rx: 13.1562,
    ry: 13.1586,
    fill: "#080808"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_109_477)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.304,
    cy: 51.0457,
    rx: 7.17614,
    ry: 7.17742,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.98 51.0457C215.98 54.7336 212.991 57.7231 209.304 57.7231C205.617 57.7231 202.628 54.7336 202.628 51.0457C202.628 47.3578 205.617 44.3683 209.304 44.3683C212.991 44.3683 215.98 47.3578 215.98 51.0457Z",
    stroke: "white",
    strokeOpacity: 0.1
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.784 51.0456C214.784 54.0729 212.331 56.5268 209.304 56.5268C206.278 56.5268 203.824 54.0729 203.824 51.0456C203.824 48.0184 206.278 45.5645 209.304 45.5645C212.331 45.5645 214.784 48.0184 214.784 51.0456Z",
    fill: "url(#paint0_linear_109_477)",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.172 54.1103C212.204 53.48 212.892 52.3433 212.892 51.0457C212.892 49.0638 211.286 47.457 209.304 47.457C208.007 47.457 206.87 48.1457 206.24 49.1774C206.784 48.8449 207.424 48.6533 208.108 48.6533C210.09 48.6533 211.696 50.26 211.696 52.242C211.696 52.9264 211.505 53.5661 211.172 54.1103Z",
    fill: "url(#paint1_linear_109_477)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M206.032 49.5706C205.829 50.0205 205.716 50.5199 205.716 51.0457C205.716 53.0277 207.323 54.6344 209.304 54.6344C209.83 54.6344 210.329 54.5214 210.779 54.3182C208.515 53.6215 206.729 51.8348 206.032 49.5706Z",
    fill: "url(#paint2_linear_109_477)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_109_477",
    x: 196.148,
    y: 37.8871,
    width: 26.3125,
    height: 27.3173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_109_477",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_109_477"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_109_477",
    x: 202.128,
    y: 43.8683,
    width: 14.3521,
    height: 15.3549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_109_477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_477",
    x1: 213.49,
    y1: 46.8588,
    x2: 205.715,
    y2: 54.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_477",
    x1: 211.796,
    y1: 48.3053,
    x2: 207.043,
    y2: 53.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A54AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_109_477",
    x1: 211.816,
    y1: 48.5336,
    x2: 207.151,
    y2: 53.1981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixel9Pro);
export default __webpack_public_path__ + "static/media/pixel-9-pro.808e9633dfea52aaba1833c970be2c80.svg";
export { ForwardRef as ReactComponent };